export function Sheet({ children }) {
  return (
    <section
      data-testid="ride-sheet"
      className="sheet fade-up fixed inset-x-0 bottom-0 z-30 max-h-[64vh] overflow-y-auto rounded-t-3xl p-5 pb-8 md:bottom-6 md:left-6 md:right-auto md:top-24 md:max-h-none md:w-[420px] md:rounded-3xl md:p-6"
    >
      <div className="mx-auto mb-4 h-1.5 w-10 rounded-full bg-border md:hidden" />
      {children}
    </section>
  );
}

export function SheetTabs({ tabs, value, onChange }) {
  return (
    <div className="mb-5 flex gap-1 rounded-full bg-muted p-1">
      {tabs.map((t) => (
        <button
          key={t.value}
          data-testid={`sheet-tab-${t.value}`}
          onClick={() => onChange(t.value)}
          className={`flex-1 rounded-full px-3 py-2 text-sm font-semibold transition-colors ${
            value === t.value ? "bg-background text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"
          }`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
